import Axios from '@/Axios'

class WorkflowStateService {
    async addWorkflowState(data) {

        return await Axios.post(`wms.wms.api.workflow_state.create_workflow_state`,data)
    }
    async getWorkflowState(data = {}) {
        const queryString = new URLSearchParams(data).toString()
        return await Axios.get(`wms.wms.api.workflow_state.get_worflow_state?${queryString}`)
    }
    async deleteWorkflowState(state) {
        const transformdState = state.map((item) => ({ name: item }))
        return await Axios.delete('wms.wms.api.workflow_state.delete_workflow_state', { data: { state: transformdState } })
    }
}
export default new WorkflowStateService()
